import type { HomePageType } from "@/types/getHome"
import { cache } from "react"
import directusServer from "./directus/directusGraphQLInstance"
import { rethrowIfDatabaseUnavailable } from "./errors/database"

const getHomepage = cache(async () => {
  try {
    const response = await directusServer.query<HomePageType>(`
      query getHomepage {
          posts(
            sort:  "-date_created",
            filter: { status: { _eq: "published" } }
            limit: 6,
          ) {
            id
            slug
            date_created
            title
            headline
            featured
            role
            evidence_metric
            read_time
            image {
              id
            }
            content_blocks {
              sort
              item {
                __typename
                ... on project_overview {
                  headline
                }
              }
            }
            category {
              category_id {
                id
                title
                slug
              }
            }
            skills {
              skills_id {
                id
                slug
                name
              }
            }
          }
          home_page {
              badge_text
              final_cta_button_label
              final_cta_button_url
              final_cta_description
              final_cta_title
              headline
              headline_highlight
              how_i_work_heading
              intro
              method_items
              metrics
              primary_cta_label
              primary_cta_url
              secondary_cta_label
              trusted_label
              work_heading
              work_range
              writing_cta_label
              writing_cta_url
              writing_heading
          }
          webpage_config {
            admin_email
            location
            cv_file {
              id
            }
          }
          companies(
            filter: {
              is_education: { _eq: false }
              active: { _eq: true }
              featured_homepage: { _eq: true }
            }
          ) {
            id
            is_education
            featured_homepage
            url
            svg_logo
            svg_logo_black
            name
          }
          testimonials(
            sort: "-date_created"
            filter: { status: { _eq: "published" } },
            ) {
              id
              title
              testimonial
              company_url
              image{
              filename_download
              id
              width
              height
            }
              score
              position
              full_name
              date_created
              company_name
              website_url
              linkedin_url
              website_url
              twitter_url
            }
        }
    `)

    return response
  } catch (error) {
    rethrowIfDatabaseUnavailable(error)
    console.error(error)
    return null
  }
})

export default getHomepage
